import { Nullable } from '../Nullable';

export interface UnitOptionLimit {
  armyOrganisationId: Nullable<number>;
  unitOptionId: number;
  limit: UnitOptionLimitLimiter;
  selectorModel: UnitOptionLimitSelectorModel;
  min: number;
  max: number;
  key: Nullable<string>;
  repeatedBy: Nullable<number>;
  isModel: boolean;
  isModelByUnit: boolean;
  isItemByArmy: boolean;
  isItemByModel: boolean;
  isMaxRatioByArmy: boolean;
}

export enum UnitOptionLimitLimiter {
  UNITS = 0,
  MODEL = 1,
  MODEL_BY_UNIT = 2,
  ITEM_BY_ARMY = 3,
  ITEM_BY_MODEL = 4,
  MAX_RATIO_BY_ARMY = 6,
}

export enum UnitOptionLimitSelectorModel {
  QUANTITY = 0,
  SELECTION = 1,
}
